<template>
    <v-container fluid>
        <v-card height="725">
            <v-card-title class="justify-center">Details {{ extra.details }}</v-card-title>
            <v-divider/>
            <v-card-text class="ma-0 pa-2 pt-3" v-if="extra.count.length>1">
                <v-row class="ma-0 pa-0" v-if="extra.count.length>1">
                    <v-col cols="3" class="ma-0 pa-0 pr-4">
                        <v-autocomplete v-model="extra.selected_count" return-object :items="extra.count" item-text="indd_oms" item-value="indd_nr" dense :multiple="false" @change="updHsidCount" label="Count"/>
                    </v-col>
                    <v-col cols="9" class="ma-0 pa-0">
                        <v-text-field v-model="search" clearable @click:clear="clearSearch" @keyup="searchDetails" label="Search" hideDetails dense/>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-text  class="pt-3 pb-6" v-else>
                <v-text-field v-model="search" clearable @click:clear="clearSearch" @keyup="searchDetails" label="Search" hideDetails dense/>
            </v-card-text>
            <v-divider/>
            <v-card-text class="detail-list" >
                <v-row class="ma-0 pa-0" v-if="extra.remark>''">
                    <v-col cols="12" class="ma-0 pa-0">
                        {{ extra.remark }}
                    </v-col>
                </v-row>
                <v-row v-for="detail in filteredDetails" :key="detail.indd_nr" class="ma-0 pa-0">
                    <v-col cols="1" class="ma-0 pa-0">
                        <v-checkbox :disabled="block" hideDetails dense v-model="detail.indd_selected" @change="updHsid(detail)" class="ma-0 pa-0"/>
                    </v-col>
                    <v-col cols="11" class="ma-0 pa-0 pl-2">
                        {{ detail.indd_oms }}
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    export default {
        components: {
        },
        props: {
            huis_encrid: {
                type: String,
                required: true                
            },
            hsii_id: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                search: "",
                block: false,
                details: [],
                extra: {
                    details: "",
                    remark: "",
                    count: [],
                    selected_count: {},
                },
                filteredDetails: [],
                lastGet: "",
            }
        },
        mounted() {
            this.getHsid();
        },
        methods: {
            clearSearch() {
                this.search = "";
                this.searchDetails();
            },
            searchDetails() {
                let newDetails = [];
                for (let iIndex=0;iIndex<this.details.length;iIndex++) {
                    if (this.details[iIndex].indd_oms.toLowerCase().includes(this.search.toLowerCase())) {
                        newDetails.push(this.details[iIndex]);
                    }
                }
                this.filteredDetails = newDetails;
            },
            getHsid() {
                if (this.lastGet !== this.huis_encrid + this.hsii_id) {
                    this.lastGet = this.huis_encrid + this.hsii_id;
                    this.$axios.post("ares/json/ares/huis/hsii/getHsid.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getHsid"
                        },
                        getHsid: {
                            huis_encrid: this.huis_encrid,
                            hsii_id: this.hsii_id,
                        }
                    }).then(res => {
                        if (res.data.error) {
                            this.$store.dispatch('setSnackbar', {
                                showing: true,
                                text: res.data.error.message,
                                color: "error"
                            }); 
                        } else {
                            this.details = res.data.getHsid; 
                            this.extra = res.data.additional;
                            this.searchDetails();
                        }
                    });
                }
            },
            updHsid(detail) {
                this.block = true;
                this.$axios.post("ares/json/ares/huis/hsii/updHsid.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updHsid"
                    },
                    updHsid: {
                        huis_encrid: this.huis_encrid,
                        hsii_id: this.hsii_id,
                        indd_nr: detail.indd_nr,
                        indd_selected: detail.indd_selected,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        }); 
                        this.block = false;
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.updHsid.text,
                            color: res.data.updHsid.color,
                        }); 
                        this.$emit("refreshLayout");
                        this.block = false;
                    }
                });
            },
            updHsidCount() {
                this.$axios.post("ares/json/ares/huis/hsii/updHsidCount.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updHsidCount"
                    },
                    updHsidCount: {
                        huis_encrid: this.huis_encrid,
                        hsii_id: this.hsii_id,
                        count: this.extra.selected_count.indd_nr,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        }); 
                        this.block = false;
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.updHsidCount.text,
                            color: res.data.updHsidCount.color,
                        }); 
                        this.$emit("refreshLayout");
                    }
                });
            },
        }  
    };
</script> 

<style scoped>
    .v-card {
        display: flex !important;
        flex-direction: column;
    }

    .detail-list {
        flex-grow: 1;
        overflow-y: auto;
    }
</style>
